import React, {useEffect, useState} from "react"
import HorizontalBanner from "@irati-web/platform/src/components/HorizontalBanner"
import {Body} from "@irati/ui/src/Typography"
import promotionsService from "@irati/promotions/services/banners"
import {FormattedMessage} from "@irati/utils/lang"
import {withTheme, WithDefaultTheme} from "styled-components"
import Flex from "@irati/ui/src/Flex"
import {PromotionType} from "@irati/types"
import {historyContext} from "@irati/utils/history"
import {FLEXIREWARDS} from "@irati-web/app/src/routeConfig"

const PhysicalOfferTopBanner: React.FC<WithDefaultTheme> = ({theme}, {app}) => {
  const [show, setShow] = useState(false)
  const isReward = app === FLEXIREWARDS
  useEffect(() => {
    if (!isReward) {
      return
    }
    promotionsService.getStatus(PromotionType.RewardChristmasMerchandise).then((merchandisePromo) => {
      setShow(merchandisePromo.enabled)
    })
  }, [])
  if (!show) {
    return null
  }
  return (
    <HorizontalBanner bgColor={theme.colors.tertiary.r_200}>
      <Flex justifyContent="center" alignItems="center" margin="auto" gap="1rem" wrap="wrap">
        <Body small color={theme.colors.greys.white} marginBottom={0}>
          <Body display="inline" textAlign="center" weight="bold" color={theme.colors.utility.ink}>
            <FormattedMessage id="platform.offer.lbl.timeOffer" />
          </Body>
          <Body display="inline" marginLeft={1} color={theme.colors.utility.ink}>
            <FormattedMessage id="perks.physicalProduct.timeOffer" />
          </Body>
        </Body>
      </Flex>
    </HorizontalBanner>
  )
}
PhysicalOfferTopBanner.contextTypes = historyContext
export default withTheme(PhysicalOfferTopBanner)
